import {Injectable} from '@angular/core';
import {BaseDao} from '../../../base-dao';
import {DotNetServerAgentUpdaterFile} from '../../../models';
import {KluhManagerValidator} from '../../../validators/kluh-manager-validator';
import {Observable} from 'rxjs';
import {R2CloudHttpApiService} from '../../../r2-cloud-http-api.service';

@Injectable({
  providedIn: 'root'
})
export class DotNetServerAgentUpdaterFileDaoService extends BaseDao<DotNetServerAgentUpdaterFile>{

    constructor(http: R2CloudHttpApiService, validatorDAO: KluhManagerValidator) {
        super(http, validatorDAO, 'server-agent-updater-file');
    }

    upload(formData: FormData): Observable<DotNetServerAgentUpdaterFile> {
        return this.http.upload(formData, this.url + `/upload`);
    }

    download(id: number): Observable<Blob> {
        return this.http.download(this.url + `/${id}/download`);
    }
}
